import { GENERATE_AI_CTA_SUCCEEDED } from '../actions/ActionTypes';
const INITIAL_STATE = {
  generatedCtas: []
};
const aiGenerationState = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GENERATE_AI_CTA_SUCCEEDED:
      return Object.assign({}, state, {
        generatedCtas: [...state.generatedCtas, action.payload]
      });
    default:
      return state;
  }
};
export default aiGenerationState;